<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <!-- <div fxHide fxShow.xs>xs</div>
    <div fxHide fxShow.sm>sm</div>
    <div fxHide fxShow.md>md</div> -->
    <div fxLayout="column" fxLayoutAlign="start stretch" class="title-line">
        <!-- Title (left) and icons (right) -->
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <h1 fxFlex [ngClass.lt-md]="'mat-display-1'" [ngClass.gt-sm]="'mat-display-3'" class="margin-bottom-none">
                <span>Principals Profiles</span>
            </h1>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                <button
                    type="button"
                    fxShow
                    fxHide.xs
                    *ngIf="User?.AuthToken"
                    mat-flat-button
                    color="primary"
                    (click)="GoHome()"
                    aria-label="Go to home page"
                >
                    <mat-icon>home</mat-icon>
                    <span>Home</span>
                </button>
                <button
                    type="button"
                    fxHide
                    fxShow.xs
                    *ngIf="User?.AuthToken"
                    mat-mini-fab
                    color="primary"
                    (click)="GoHome()"
                    aria-label="Go to home page"
                >
                    <mat-icon>home</mat-icon>
                </button>
                <button
                    type="button"
                    mat-mini-fab
                    (click)="ToggleTheme()"
                    [matTooltip]="CurrentTheme === 'my-light-theme' ? 'Switch to dark mode' : 'Switch to light mode'"
                    [title]="CurrentTheme === 'my-light-theme' ? 'Switch to dark mode' : 'Switch to light mode'"
                >
                    <mat-icon>{{ CurrentTheme === 'my-light-theme' ? 'dark_mode' : 'light_mode' }}</mat-icon>
                </button>
                <button
                    type="button"
                    mat-mini-fab
                    color="primary"
                    (click)="ToolbarAbout()"
                    aria-label="See application help information"
                >
                    <mat-icon>help</mat-icon>
                </button>
                <button
                    type="button"
                    fxShow
                    fxHide.xs
                    *ngIf="User?.AuthToken"
                    mat-flat-button
                    color="primary"
                    (click)="ToolbarLogout()"
                    aria-label="Logout of application"
                >
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>
                <button
                    type="button"
                    fxHide
                    fxShow.xs
                    *ngIf="User?.AuthToken"
                    mat-mini-fab
                    (click)="ToolbarLogout()"
                    aria-label="Logout of application"
                >
                    <mat-icon>exit_to_app</mat-icon>
                </button>
            </div>
        </div>
        <!-- User message -->
        <app-user-info *ngIf="User" [user]="User"></app-user-info>
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" class="scrollable">
        <!-- <div class="devbar" *ngIf="DevSite === true && SmallDisplay"><div>Development Site</div></div> -->
        <div fxFlex="1 1 auto" class="routerwrapper" fxLayout="column" fxLayoutAlign="start stretch">
            <!--
            [class.updatebarheight]="UpdateAvailable === true"
            [class.devbarheight]="DevSite === true" -->
            <router-outlet class="content"></router-outlet>
        </div>
    </div>
</div>
